import type { UseFormReturn } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import { FieldGroup, Label, TextArea, TextField } from '@launchpad-ui/components';

import type { MetricForm } from './formUtils';
import { MetricKeyNameFields } from './MetricKeyNameFields';

import styles from './CreateMetricModal.module.css';

interface MetricMetadataProps {
  context: UseFormReturn<MetricForm>;
  isEdit?: boolean;
  fullWidth?: boolean;
}

export const MetricMetadata: React.FC<MetricMetadataProps> = ({ context, isEdit = false, fullWidth = false }) => {
  const {
    control,
    register,
    formState: { errors },
  } = context;

  const description = useWatch({ control, name: 'description', exact: true });

  return (
    <>
      <MetricKeyNameFields context={context} isEdit={isEdit} fullWidth={fullWidth} />
      <FieldGroup errorMessage={errors.description?.message}>
        <TextField className={fullWidth ? styles.descriptionInputFullWidth : styles.descriptionInput}>
          <Label htmlFor="description">Description</Label>
          <TextArea
            id="description"
            value={description}
            {...register('description', { value: context.getValues('description') })}
            placeholder="Add a description"
          />
        </TextField>
      </FieldGroup>
    </>
  );
};
